/**
 * Assistant API — chat conversacional con la IA "Deenex".
 *
 * Distinto del inbox (que son eventos pushed por el sistema). El assistant
 * es bidireccional: vos preguntás, la IA responde con texto + acciones
 * contextuales.
 *
 * Endpoints (mockeados):
 *   GET  /assistant/history          → historial completo
 *   POST /assistant/chat { text }    → enviar mensaje, recibir respuesta
 *   POST /assistant/clear            → vaciar el historial
 */

import { apiClient } from "./client";

export type AssistantRole = "user" | "assistant";

export interface AssistantAction {
    label: string;
    link?: string;
    variant?: "primary" | "secondary";
}

export interface AssistantMessage {
    id: string;
    role: AssistantRole;
    content: string;
    actions?: AssistantAction[];
    createdAt: string;
}

interface ApiResponse<T> {
    success: boolean;
    data?: T;
    error?: string;
}

export const assistantApi = {
    async history(): Promise<ApiResponse<AssistantMessage[]>> {
        try {
            const r = await apiClient.get<ApiResponse<AssistantMessage[]>>(
                "/assistant/history",
            );
            return r.data;
        } catch (e: any) {
            return { success: false, error: e?.message || "Error" };
        }
    },

    async chat(
        text: string,
    ): Promise<
        ApiResponse<{
            userMessage: AssistantMessage;
            assistantMessage: AssistantMessage;
        }>
    > {
        try {
            const r = await apiClient.post<
                ApiResponse<{
                    userMessage: AssistantMessage;
                    assistantMessage: AssistantMessage;
                }>
            >("/assistant/chat", { text });
            return r.data;
        } catch (e: any) {
            return { success: false, error: e?.message || "Error" };
        }
    },

    async clear(): Promise<ApiResponse<void>> {
        try {
            const r = await apiClient.post<ApiResponse<void>>(
                "/assistant/clear",
            );
            return r.data;
        } catch (e: any) {
            return { success: false, error: e?.message || "Error" };
        }
    },
};
